import { Grid, Typography, Box } from "@mui/material";
import styles from "./index.module.css";
import { formatPresentationDate } from "../../../utils/common";

const LOGO = "https://elitepromomarketing.com/wp-content/uploads/2024/08/logo-1-600x183.png";

const Header = ({ presentationDate, id, Introduction, headerConfig, isLoaded = false }) => {
  const formattedDate = presentationDate ? formatPresentationDate(presentationDate) : "";
  const showMeta = Boolean(isLoaded && id && formattedDate);
  const resolvedLogo = headerConfig?.logoUrl || LOGO;
  const companyName = headerConfig?.companyName || "Elite Promotional Marketing";
  const primaryMetaLine = `Presentation #${id || "N/A"}${Introduction ? ` for ${Introduction}` : ""}`;
  const secondaryMetaLine = formattedDate ? `${formattedDate} - Promotional Items` : "Promotional Items";
  const headerStyle = {
    backgroundImage: headerConfig?.backgroundUrl ? `url('${headerConfig.backgroundUrl}')` : undefined,
    backgroundColor: headerConfig?.backgroundColor || undefined,
  };

  return (
    <>
      <Grid container className={`${styles.headerContainer} ${styles.screenOnly}`} style={headerStyle}>
        <Grid item xs={1.5} className={styles.headerLogoContainer}>
          <img src={resolvedLogo} className={styles.headerLogo} alt="Logo" />
        </Grid>
        <Grid item xs={5} className={styles.TitleContainer}>
          <Box className={styles.titleContent}>
            <Typography variant="h4" gutterBottom color="white">
              {companyName}
            </Typography>
            <Typography variant="body1" color="white" sx={{ visibility: showMeta ? "visible" : "hidden" }}>
              {primaryMetaLine}
              <br />
              {secondaryMetaLine}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <header className={styles.printOnly}>
        <div className={styles.printBrandRow}>
          <div className={styles.printLogoColumn}>
            <img src={resolvedLogo} alt={`${companyName} logo`} />
          </div>
          <div className={styles.printDocumentIdentity}>
            <h1>{companyName}</h1>
            <div>{primaryMetaLine}</div>
            <div>{secondaryMetaLine}</div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
